import { action } from 'satcheljs';
import InboxPlusPivotViewState from 'owa-mail-inbox-plus-store/lib/store/schema/InboxPlusPivotViewState';

export const setShouldShowPivotEnableDisableDialog = action(
    'SET_IS_PIVOT_REORDER_DIALOG_SHOWN',
    (shouldShow: boolean) => ({
        shouldShow,
    })
);

export const pivotToggled = action('PIVOT_TOGGLED', (pivot: InboxPlusPivotViewState) => ({
    pivot,
}));

export const focusedOtherPivotsToggled = action('FOCUSED_OTHER_PIVOTS_TOGGLED');
